// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/about-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutBanner {
  height: 430px;
  min-width: 1200px;
  background: #e1e8f2 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top center;
}
.aboutCoctent {
  width: 1200px;
  margin: 0px auto;
  font-size: 16px;
  line-height: 34px;
}
.aboutCoctent p {
  text-indent: 30px;
}
.companyTv {
  width: 1200px;
  margin: 0px auto;
  font-size: 16px;
  line-height: 34px;
  display: flex;
  padding-top: 30px;
}
.companyTv-right {
  display: flex;
  padding: 0px 10px;
  width: 100%;
  justify-content: space-around;
}
.companyTv-right dl {
  margin: 0px 0px 20px 20px;
  width: calc(50% - 20px);
}
.companyTv-right dl:first-child {
  margin-left: 0px;
}
.companyTv-right dt {
  height: 150px;
  overflow: hidden;
  border: 5px solid #ddd;
  text-align: center;
}
.companyTv-right dt img {
  width: 100%;
  height: 150px;
}
.companyTv-right dd {
  margin-left: 0px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/About/index.less"],"names":[],"mappings":"AAAA;EAAa,aAAA;EAAc,iBAAA;EAAkB,gFAAA;AAI7C;AAHA;EAAc,aAAA;EAAc,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;AAS7D;AATA;EACK,iBAAA;AAWL;AARA;EAAW,aAAA;EAAc,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAmB,aAAA;EAAe,iBAAA;AAgB5F;AAfG;EAAQ,aAAA;EAAe,iBAAA;EAAkB,WAAA;EAAY,6BAAA;AAqBxD;AArBG;EACM,yBAAA;EAA0B,uBAAA;AAwBnC;AAzBG;EAEkB,gBAAA;AA0BrB;AA5BG;EAGM,aAAA;EAAc,gBAAA;EAAkB,sBAAA;EAAuB,kBAAA;AA+BhE;AAlCG;EAIU,WAAA;EAAY,aAAA;AAkCzB;AAtCG;EAMM,gBAAA;EAAkB,kBAAA;AAoC3B","sourcesContent":[".aboutBanner{height:430px; min-width:1200px; background:#e1e8f2 url(../../static/images/about-banner.jpg) no-repeat top center;}\n.aboutCoctent{width:1200px; margin:0px auto; font-size:16px; line-height: 34px;\n   p{text-indent:30px;}\n\n}\n.companyTv{width:1200px; margin:0px auto; font-size:16px; line-height: 34px; display: flex; padding-top:30px;\n   &-right{display: flex; padding:0px 10px; width:100%; justify-content: space-around;\n      dl{margin:0px 0px 20px 20px; width:calc(50% - 20px); }\n      dl:first-child{margin-left:0px;}\n      dt{height:150px; overflow: hidden; border:5px solid #ddd; text-align: center;\n         img{width:100%; height:150px}\n      }\n      dd{margin-left: 0px; text-align: center;}\n   }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
